import { codeGenFactory, makeAuthenticatedRequest } from '@rhizome/codegen';
import { auth } from 'libs/shared-firebase/src';
import { getLinkPreview } from 'link-preview-js';

const getAuth = () => {
  const token = auth.currentUser?.getIdToken();
  return token || null;
};

const codeGenerator = codeGenFactory({
  getAuth,
  url: process.env.NEXT_PUBLIC_HTTP_URL!,
});

export const createFetcher = codeGenerator.fetch;

export const useFetcher = codeGenerator.useFetchHook;

export const useInfiniteFetcher = codeGenerator.useInfiniteFetchHook;

export const usePaginatedQuery = codeGenerator.usePaginatedQuery;

export const useMutationHook = codeGenerator.useMutationHook;

export type LinkPreviewBody = {
  url: string;
};

export const GetLinkPreview = (
  body: LinkPreviewBody
): ReturnType<typeof getLinkPreview> => {
  return makeAuthenticatedRequest(
    process.env.NEXT_PUBLIC_HTTP_URL!,
    'GetLinkPreview',
    body,
    getAuth
  );
};
